/* unplugin-vue-components disabled */import script from "./CreateCaseDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCaseDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateCaseDialog.vue?vue&type=style&index=0&id=12353495&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户南京邮电-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12353495"]])

export default __exports__